import React, {useState} from 'react';
import {Accordion} from '../../Accordion/Accordion';
import {ContentWrapper} from './FileMetaDataTabDisclaimer.style';
import {t} from 'i18next';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import EventEmitter from 'events';
import {FileMetaDataDialog_changeDisclaimer} from '../../../init/events';
import {DisclaimerPicker} from '../../DisclaimerPicker/DisclaimerPicker';
import {DisclaimerDTO} from '../../../models/dto/DisclaimerDTO';
import {NO_DISCLAIMER_KEY} from '../../../init/constants';

export interface FileMetaDataTabDisclaimerProps {
    readonly disclaimerData: DisclaimerDTO[];
    readonly disclaimer?: string;
    readonly watermark: boolean;
    readonly eventEmitter: EventEmitter;
}

/**
 * @name FileMetaDataTabDisclaimer
 * @description
 * The dialog to add the metadata of a newly created file or edited file - Metadata Tabs
 */
export const FileMetaDataTabDisclaimer: React.VFC<FileMetaDataTabDisclaimerProps> = (props) => {
    const [disclaimerInput, setDisclaimerInput] = useState<string>(props.disclaimer ?? NO_DISCLAIMER_KEY);
    const [watermarkInput] = useState<boolean>(props.watermark ?? false);

    const handleChangeDisclaimer = (disclaimer: string) => {
        setDisclaimerInput(disclaimer);
        props.eventEmitter.emit(FileMetaDataDialog_changeDisclaimer, disclaimer);
    };

    return (
        <ContentWrapper id={generateIdentifier()}>
            <Accordion accordionHeadline={t('CREATE_EDIT_FILE_DIALOG_ACCORDION_TITLE_DISCLAIMER')}
                       startOpen>
                <DisclaimerPicker dataSource={props.disclaimerData}
                                  disclaimer={disclaimerInput}
                                  watermark={watermarkInput}
                                  onChange={handleChangeDisclaimer}/>
            </Accordion>
        </ContentWrapper>
    );
}